import http from '../util/request.js'

export const doLogin = (params) =>{
	return http({
		url:'/apistore/store/login',
		data:params,
		method:'post'
	})
}
export const loginToken = (params) =>{
	return http({
		url:'/apistore/store/loginToken',
		data:params,
		method:'get'
	})
}

export const sendVerifyCode = (params) =>{
	return http({
		url:'/apistore/store/sendVerifyCode',
		data:params,
		method:'post'
	})
}


export const logOut = (params) =>{
	return http({
		url:'/apistore/home/logOut',
		data:params,
		method:'get'
	})
}
export const storeUrl = (params) =>{
	return http({
		url:'/apistore/home/storeUrl',
		data:params,
		method:'get'
	})
}
export const sendResetVerifyCode = (params) =>{
	return http({
		url:'/apistore/store/sendResetVerifyCode',
		data:params,
		method:'post'
	})
}
export const resetVerPassword = (params) =>{
	return http({
		url:'/apistore/store/resetVerPassword',
		data:params,
		method:'post'
	})
}
export const updateStoreMsg = (params) =>{
	return http({
		url:'/apistore/home/updateStoreMsg',
		data:params,
		method:'get'
	})
}
export const queryStoreMsg = (params) =>{
	return http({
		url:'/apistore/home/queryStoreMsg',
		data:params,
		method:'get'
	})
}
export const getlogo = (params) =>{
	return http({
		url:'/apistore/store/getlogo',
		data:params,
		method:'get'
	})
}